import React, { useEffect, useRef, useState } from "react";

const CustomCursor = () => {
  const dot = useRef(null);
  const ring = useRef(null);
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const isTouch = window.matchMedia("(hover: none), (pointer: coarse)").matches;
    if (isTouch) {
      setEnabled(false);
      document.body.style.cursor = "auto";
      return;
    }

    let rx = window.innerWidth / 2;
    let ry = window.innerHeight / 2;
    let dx = rx;
    let dy = ry;
    let frame;

    const onMove = (e) => {
      dx = e.clientX;
      dy = e.clientY;
      if (dot.current) {
        dot.current.style.transform = `translate(${dx}px, ${dy}px) translate(-50%, -50%)`;
      }
    };

    const animate = () => {
      rx += (dx - rx) * 0.18;
      ry += (dy - ry) * 0.18;
      if (ring.current) {
        ring.current.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
      }
      frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);

    const setHot = () => {
      dot.current?.classList.add("hot");
      ring.current?.classList.add("hot");
    };
    const setCold = () => {
      dot.current?.classList.remove("hot");
      ring.current?.classList.remove("hot");
    };

    const interactiveSelector = "a, button, [role='button'], input, textarea, select, label";
    const onOver = (e) => {
      if (e.target.closest && e.target.closest(interactiveSelector)) setHot();
    };
    const onOut = (e) => {
      if (e.target.closest && e.target.closest(interactiveSelector)) setCold();
    };

    window.addEventListener("mousemove", onMove);
    document.addEventListener("mouseover", onOver);
    document.addEventListener("mouseout", onOut);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onOver);
      document.removeEventListener("mouseout", onOut);
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      <div ref={ring} className="replay-cursor-ring hidden md:block" aria-hidden="true" />
      <div ref={dot} className="replay-cursor hidden md:block" aria-hidden="true" />
    </>
  );
};

export default CustomCursor;
